import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EventDetails, EventsParams } from "./events-page-model";

@Injectable({
  providedIn: "root",
})
export class EventsPageDataService {
  constructor(private http: HttpClient) {}

  baseUrl = `${window.apiUrl}/eventsapi/api`;
  baseParams = [];
  baseBody = {};

  getEvents = (
    companySymbologyId: number,
    getEventsParams?: EventsParams,
    fromCustomConsensus?: boolean,
  ): Observable<any> => {
    const body = {
      ...this.baseBody,
      refdata_company_id: companySymbologyId,
      from_custom_consensus: fromCustomConsensus ? true : false,
    };

    if (getEventsParams) {
      if (Number.isInteger(getEventsParams.page_start)) {
        body["page_start"] = getEventsParams.page_start;
      }
      if (Number.isInteger(getEventsParams.page_end)) {
        body["page_end"] = getEventsParams.page_end;
      }
      if (getEventsParams.eventId && getEventsParams.eventId.length > 0) {
        body["event_id"] = getEventsParams.eventId;
      }
      if (getEventsParams.broker_id && getEventsParams.broker_id.length > 0) {
        body["publisher_id"] = getEventsParams.broker_id;
      }
      if (getEventsParams.start_date) {
        body["start_date"] = getEventsParams.start_date;
      }
      if (getEventsParams.end_date) {
        body["end_date"] = getEventsParams.end_date;
      }
      if (getEventsParams.event_type && getEventsParams.event_type.length > 0) {
        body["event_type"] = getEventsParams.event_type;
      }
      if (getEventsParams.analyst && getEventsParams.analyst.length > 0) {
        body["analyst"] = getEventsParams.analyst;
      }
      if (getEventsParams.city && getEventsParams.city.length > 0) {
        body["city"] = getEventsParams.city;
      }
      if (getEventsParams.country && getEventsParams.country.length > 0) {
        body["country"] = getEventsParams.country;
      }
      if (getEventsParams.sort_by && getEventsParams.sort_by.length > 0) {
        body["sort_by"] = getEventsParams.sort_by;
      }
    }

    return this.http.post(`${this.baseUrl}/get_events`, body);
  };

  getAnalysts = (companySymbologyId: number): Observable<any> => {
    const params = [...this.baseParams];
    params.push(`refdata_company_id=${companySymbologyId}`);
    return this.http.get(
      `${this.baseUrl}/get_analysts_by_symbol?${params.join("&")}`,
    );
  };

  getBrokers = (companySymbologyId: number): Observable<any> => {
    const params = [...this.baseParams];
    params.push(`refdata_company_id=${companySymbologyId}`);
    return this.http.get(
      `${this.baseUrl}/get_brokers_by_symbol?${params.join("&")}`,
    );
  };

  getEventTypes = (companySymbologyId: number): Observable<any> => {
    const params = [...this.baseParams];
    params.push(`refdata_company_id=${companySymbologyId}`);
    return this.http.get(`${this.baseUrl}/get_event_type?${params.join("&")}`);
  };

  getCities = (companySymbologyId: number): Observable<any> => {
    const params = [...this.baseParams];
    params.push(`refdata_company_id=${companySymbologyId}`);
    return this.http.get(`${this.baseUrl}/get_city?${params.join("&")}`);
  };

  getCountries = (companySymbologyId: number): Observable<any> => {
    const params = [...this.baseParams];
    params.push(`refdata_company_id=${companySymbologyId}`);
    return this.http.get(`${this.baseUrl}/get_country?${params.join("&")}`);
  };

  getEventDetails = (eventId: number): Observable<EventDetails> => {
    const params = [...this.baseParams];
    params.push(`event_id=${eventId}`);
    return this.http.get(
      `${this.baseUrl}/get_event_details?${params.join("&")}`,
    );
  };

  getEventsMeta = (ticker: string): Observable<any> => {
    return this.http.get(
      `${window.apiUrl}/api/get_events_meta?ticker=${ticker}`,
    );
  };
}
